import { useContext } from 'react';
import { AccountContext, AccountContextInterface } from './AccountContext';

export const useAccount = (): AccountContextInterface =>
  useContext(AccountContext);
